import { React, useState } from "react";
import "./main-page.css";

const MainPage = ({ credential, handleRemoteRequest, serverConnected }) => {
  const [clientCredential, setClientCredential] = useState({
    userName: "",
    remoteId: "",
    password: "",
  });

  const handleClientCredential = (e) => {
    setClientCredential((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="remote-main-wrapper">
      <div className="remote-cards-row">

        {/* ── Allow Remote Control ── */}
        <div className="remote-panel-card">
          <div className="remote-panel-header">
            <div className="remote-panel-icon">
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/>
                <path fillRule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>
              </svg>
            </div>
            <h3 className="remote-panel-title">Allow Remote Control</h3>
          </div>

          <div className="credential-field">
            <span className="credential-field-label">Remote ID</span>
            <div className="credential-field-value">
              <span className="cred-id">
                {credential !== null ? credential.id : "—"}
              </span>
            </div>
          </div>

          <div className="credential-field">
            <span className="credential-field-label">Password</span>
            <div className="credential-field-value">
              <span className="cred-id">
                {credential !== null ? credential.password : "—"}
              </span>
            </div>
          </div>
        </div>

        {/* ── Control Remote Computer ── */}
        <div className="remote-panel-card">
          <div className="remote-panel-header">
            <div className="remote-panel-icon" style={{ background: "rgba(6,182,212,0.1)", color: "#0891b2" }}>
              <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"/>
                <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
              </svg>
            </div>
            <h3 className="remote-panel-title">Control Remote Computer</h3>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); handleRemoteRequest(clientCredential); }}>
            <div className="rc-form-group">
              <input
                type="text"
                className="rc-input"
                name="userName"
                value={clientCredential.userName}
                onChange={handleClientCredential}
                placeholder="Your Name"
                autoComplete="off"
              />
            </div>

            <div className="rc-form-group">
              <input
                type="text"
                className="rc-input"
                name="remoteId"
                value={clientCredential.remoteId}
                onChange={handleClientCredential}
                placeholder="Client PC Remote ID"
                autoComplete="off"
              />
            </div>

            <div className="rc-form-group">
              <input
                type="password"
                className="rc-input"
                name="password"
                value={clientCredential.password}
                onChange={handleClientCredential}
                placeholder="Password"
                autoComplete="on"
              />
            </div>

            <button
              type="submit"
              className={`rc-connect-btn ${serverConnected ? "connected" : "error"}`}
              disabled={!serverConnected}
            >
              {serverConnected ? "Connect" : "Network Error"}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
};

export default MainPage;
